import { cloneElement, isValidElement, useLayoutEffect, useState } from 'react';
import { Tooltip } from '@crazyegginc/hatch';

export function getCriteriaTooltipContent(criteria) {
  return `You can change the ${criteria.label} condition here.`;
}

export function getValueTooltipContent(criteria) {
  return `You can add another ${criteria.tooltipLabel ?? criteria.label.toLowerCase()} here.`;
}

export function ConditionTooltip({
  children,
  content,
  criteria,
  type = 'value',
  show,
  onDismiss,
  skiddingPercent = '80',
}) {
  const [hasBeenShown, setHasBeenShown] = useState(show);
  const shouldDismissOnTargetInteraction = show && type === 'value';

  useLayoutEffect(() => {
    if (show) {
      setHasBeenShown(true);
    }
  }, [show]);

  if (!show && !hasBeenShown) {
    return children;
  }

  const tooltipContent =
    content ||
    (criteria ? (type === 'criteria' ? getCriteriaTooltipContent(criteria) : getValueTooltipContent(criteria)) : '');
  const tooltipContainerStyle = show ? { zIndex: 100000 } : { display: 'none' };
  const tooltipTarget = getTooltipTarget(children, {
    onDismiss,
    shouldDismissOnTargetInteraction,
  });

  return (
    <Tooltip
      containerStyle={tooltipContainerStyle}
      hover={false}
      placement="bottom"
      skiddingPercent={skiddingPercent}
      arrowSkiddingPercent="20"
      offset="0"
      onDismiss={onDismiss}
      tooltipContent={<div className="w-[130px] text-left">{tooltipContent}</div>}
    >
      {tooltipTarget}
    </Tooltip>
  );
}

function getTooltipTarget(children, { onDismiss, shouldDismissOnTargetInteraction }) {
  if (!shouldDismissOnTargetInteraction || !isValidElement(children)) {
    return children;
  }

  return cloneElement(children, {
    onFocusCapture: callAll(children.props.onFocusCapture, onDismiss),
    onPointerDownCapture: callAll(children.props.onPointerDownCapture, onDismiss),
  });
}

function callAll(...handlers) {
  return (...args) => {
    handlers.forEach((handler) => handler?.(...args));
  };
}
